import { createContext, useContext, type ReactNode } from "react";

const InsideMain = createContext(false);

/**
 * The page's one `main`, which the root's skip link targets. Screens that can hold another
 * screen's content — a layout, or a page with a waiting state — render through this, so what
 * they hold can tell that the landmark already exists rather than add a second one.
 */
export function MainLandmark({
  children,
  className,
}: {
  children: ReactNode;
  className?: string | undefined;
}) {
  return (
    <main id="main" className={className}>
      <InsideMain.Provider value={true}>{children}</InsideMain.Provider>
    </main>
  );
}

/** Whether this is already inside the page's `main`. */
export function useInsideMain() {
  return useContext(InsideMain);
}
